type Translate = (key: string) => string;

const FALLBACK_LABELS: Record<string, string> = {
  white: 'White',
  bronze: 'Bronze',
  silver: 'Silver',
  gold: 'Gold',
  platinum: 'Platinum',
  newsletter: 'Newsletter',
  voice_memo: 'Voice Memo',
  digest: 'Digest',
  tweet: 'Tweet',
  ama: 'AMA',
  draft: 'Draft',
  published: 'Published',
  active: 'Active',
  ended: 'Ended',
  online: 'Online',
  offline: 'Offline',
  included: 'Included',
  consumable: 'Consumable',
};

function humanize(value: string): string {
  return value
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}

function getLabel(t: Translate, key: string, fallbackValue: string): string {
  const translated = t(key);
  return translated === key
    ? FALLBACK_LABELS[fallbackValue] || humanize(fallbackValue)
    : translated;
}

export function getTierLevelLabel(t: Translate, tier: string | null | undefined): string {
  if (!tier) return '';
  return getLabel(t, `joc_club.labels.tiers.${tier}`, tier);
}

export function getTierLevelBadgeLabel(t: Translate, tier: string | null | undefined): string {
  const label = getTierLevelLabel(t, tier);
  return label ? `${label}+` : '';
}

export function getNewsCategoryLabel(t: Translate, category: string | null | undefined): string {
  if (!category) return '';
  return getLabel(t, `joc_club.labels.news_categories.${category}`, category);
}

export function getStatusLabel(t: Translate, status: string | null | undefined): string {
  if (!status) return '';
  return getLabel(t, `joc_club.labels.statuses.${status}`, status);
}

export function getEventTypeLabel(t: Translate, type: string | null | undefined): string {
  if (!type) return '';
  return getLabel(t, `joc_club.labels.event_types.${type}`, type);
}

export function getBenefitCategoryLabel(t: Translate, category: string | null | undefined): string {
  if (!category) return '';
  return getLabel(t, `joc_club.labels.benefit_categories.${category}`, category);
}
